export const getExpanderRowId = (rowId: string) => `expander-row-${rowId}`;
